import Header from "Components/FeatureFlip/Features/Header/Header";
import styles from './styles/FeatureDetails.module.css'
import Treatment from "Components/FeatureFlip/Features/Treatment/Treatment";
import { useFeatureFlipStore } from "Store/featureFlipStore";
import { useGetAllTreatments } from "API/Queries/useGetAllTreatments";
import { useParams } from "react-router-dom";
import { Treatment as TreatmentType } from "API/Queries/useGetAllTreatments";
import { useEffect } from "react";
import TargetingRules from "Components/FeatureFlip/Features/TargetingRules/TargetingRules";
import { getNextAvailableColor } from "Utils/utils";
import { useGetAllFeatures } from "API/Queries/useGetAllFeatures";
import { Feature } from "Store/stateInterfaces";

const FeatureDetails = () => {
  const { id, featureId } = useParams();
  const { setEditedTreatments, setExistingTreatments, setColors, setIsFeatureEnabled, setIsFeatureDynamic } = useFeatureFlipStore();

  const { refetch: getAllTreatments } = useGetAllTreatments( featureId as string , {
    onSuccess: async (treatments: TreatmentType[]) => {
      setExistingTreatments(treatments);
      setEditedTreatments(treatments)
      const colors = treatments.map((ele)=>getNextAvailableColor())
      setColors(colors)
    }
  });

  const { refetch: getFeatureDetails } = useGetAllFeatures(
    { query: `projectId==${id};id==${featureId}` },
    {
      onSuccess: (features: Feature[]) => {
        const feature = features.find((f) => f.id === featureId);
        if (feature) {
          setIsFeatureEnabled(feature.enabled);
          setIsFeatureDynamic(feature.dynamic);
        }
      },
    }
  );

  useEffect(()=>{
    getAllTreatments();
    getFeatureDetails();
  },[]);

  return   <div className={styles.container}>
 <Header />
 <Treatment />
 <TargetingRules/>


</div>

}
export default FeatureDetails; 